import { useCallback } from 'react';

import { useLocale } from '../context';
import { DateFormatOptions, DateIsoString } from '../entities/Date/Date';
import { formatDate } from '../helpers/date';

type DateFormatFunction = (date?: DateIsoString, options?: DateFormatOptions) => string;

export const useFormatDate = (): DateFormatFunction => {
    const { language } = useLocale();

    return useCallback<DateFormatFunction>((date, options) => formatDate({
        date,
        language,
        options,
    }), [language]);
};
